import { render, staticRenderFns } from "./DispatchsDetaisl.vue?vue&type=template&id=d730cdce&scoped=true&"
import script from "./DispatchsDetaisl.vue?vue&type=script&lang=js&"
export * from "./DispatchsDetaisl.vue?vue&type=script&lang=js&"
import style0 from "./DispatchsDetaisl.vue?vue&type=style&index=0&id=d730cdce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d730cdce",
  null
  
)

export default component.exports